<script setup lang="ts">

</script>

<template>
  <footer id="footer" class="footer">
    <div class="text-lh-green-light py-2 text-lg text-center">
      ©2020-{{new Date().getFullYear()}} Loreheart
    </div>
  </footer>
  
</template>

<style scoped lang="scss">

</style>
